import React from 'react';

/**
 * Компонент "Мнение автора"
 */
export const AuthorOpinionDisclaimer = () => (
  <p id={'author-opinion-disclaimer'}>Мнение автора может не совпадать с мнением редакции</p>
);
